import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModelDocumentsShow } from '../../../interfaces/interfaces';
import { DialogService } from '../../../services/utils/dialog.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import {SnackBarService} from '../../../services/utils/snackBar.service';

export interface DialogData {
  urlType: string;
  url: string;
  typeOperator: string;
  files?: File[]
}

@Component({
  selector: 'app-dialog-change-one-file',
  templateUrl: './dialog-change-one-file.component.html',
  styleUrls: ['./dialog-change-one-file.component.scss']
})
export class DialogChangeOneFileComponent implements OnInit {
  url = '';
  s3Bucket: string;
  formFile: FormGroup;

  files: File[] = [];

  private readonly MAX_BYTES = 5 * 1024 * 1024; // 5 MB
  private readonly ALLOWED_MIMES = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
  private readonly ALLOWED_EXT   = /\.(pdf|jpg|jpeg|png)$/i;

  constructor(
    private dialogRef: MatDialogRef<DialogChangeOneFileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dialogService: DialogService,
    private fb: FormBuilder,
    private snackBService: SnackBarService,
  ) {
    this.files ? this.files = this.data.files: '';
    this.formFile = this.fb.group({
      File: ''
    });
   }


  ngOnInit(): void {
    this.s3Bucket= environment.api.s3Bucket;
    if(this.data.urlType === 'Complete' && this.data.url !== '' && this.data.url !== null) {
      let a = this.data.url.split('https://analityco-acceso.s3.amazonaws.com/');
      if(a !== undefined) {
        this.url = a[1];
      }
    } else if(this.data.urlType === 'Incomplete' && this.data.url !== '' && this.data.url !== null) {
      this.url = this.data.url;
    }
  }

  openImgVideo(url: string) {
    this.dialogService.openDialogImageOrVideoOrPdf(url).afterClosed().subscribe(x => {});
  }

  onNoClick(): void {
    this.dialogRef.close();
    this.getName();
  }

  getName(): string {
    let name: string;
    if(this.url !== '') {
      let arrayDeCadenas = this.url.split('/');
      name = arrayDeCadenas.pop();
    }
    return name;
  }

  getUrl(doc: ModelDocumentsShow): string {
    let url = ''
    let a = doc?.urlDoc?.split('||name=');
    if(a !== undefined) {
      url = a[0];
    }
    return url;
  }

  private isAllowed(f: File): boolean {
    const okMime = this.ALLOWED_MIMES.includes(f.type);
    const okExt  = this.ALLOWED_EXT.test((f.name || '').toLowerCase());
    return okMime && okExt;
  }

  private validateAndSetSingleFile(list: FileList | File[]): void {
    this.files = [];

    const f = (Array.isArray(list) ? list[0] : list?.[0]) as File;
    if (!f) { return; }

    if (!this.isAllowed(f)) {
      this.snackBService.openWarning('Solo se permite subir archivos en formatos PDF, JPG o PNG.', '', 5000);
      return;
    }

    if (f.size > this.MAX_BYTES) {
      this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', '', 5000);
      return;
    }

    this.files = [f];
  }

  onSelect(event: { addedFiles: File[] }) {
    const selectedFiles: File[] = event?.addedFiles || [];
    this.validateAndSetSingleFile(selectedFiles);
  }

  updatePhoto() {
    if (this.files.length !== 1) { return; }

    const f = this.files[0];

    if (!this.isAllowed(f)) {
      this.snackBService.openWarning('Solo se permite subir archivos en formatos PDF, JPG o PNG.', '', 5000);
      return;
    }
    if (f.size > this.MAX_BYTES) {
      this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', '', 5000);
      return;
    }

    const formData = new FormData();
    formData.append('File', f);

    this.dialogRef.close({ FormData: formData, File: this.files });
  }

  isXLSX(doc: any): boolean {
    return this.getUrl(doc).slice(-5).toUpperCase() === '.XLSX';
  }

  getUrlFile(url) {
    const urlFile = this.s3Bucket+this.getUrl(url)
    return urlFile;
  }

}
